import '../css/Home.css';

const Home = () => {
    return (
      <div className="coming-soon-container">
        <h1 className="coming-soon-title">🚕 RaveCabs is coming soon!</h1>
        <p className="coming-soon-description">
          We’re building a smarter, faster, and more reliable taxi service for your city.
          Stay tuned for fast rides, seamless booking, and a great travel experience.
        </p>
        <p className="coming-soon-footer">
          Launching soon in Jaipur 🚀
        </p>
      </div>
    );
  };
  
export default Home;
  